import { KEY_CODES } from '../../../common/types/keyCodes';
/**
 * Runs preventDefault for a KeyboardEvent dependending on what key is pressed
 * - arrow up/down
 *    This prevents the input cursor from automatically moving to the start/end
 *
 * @param {KeyboardEvent<HTMLInputElement>} event
 */
export var handleInputPreventDefault = function (event) {
    return [KEY_CODES.ARROW_DOWN.key, KEY_CODES.ARROW_UP.key, KEY_CODES.ENTER.key].includes(event.key) &&
        event.preventDefault();
};
//# sourceMappingURL=handleInputPreventDefault.js.map